import React, { useState, useContext } from 'react';
import {
  MDBContainer,
  MDBNavbar,
  MDBNavbarBrand,
  MDBNavbarToggler,
  MDBNavbarNav,
  MDBNavbarItem,
  MDBNavbarLink,
  MDBCollapse,
  MDBBtn
} from 'mdb-react-ui-kit';
import template from '../../qualtio-logo.png';
import { AuthContext } from '../../context/AuthContext';

export default function App() {
    const [showNav, setShowNav] = useState(false);
    const { user, logout, userPicture } = useContext(AuthContext);
    let render = false;

    if (user && user !== 'null') {
        render = true;
    }

    return (
        <MDBNavbar expand='lg' light bgColor='light'>
            <MDBContainer fluid>
                <MDBNavbarBrand href='/calendario'>
                    <img 
                        src={template} 
                        alt='logo'
                        height='45px'
                        loading='lazy'
                    />
                </MDBNavbarBrand>
                <MDBNavbarToggler
                    aria-expanded='false'
                    aria-label='Toggle navigation'
                    onClick={() => setShowNav(!showNav)}
                >
                    <span className='navbar-toggler-icon'></span>
                </MDBNavbarToggler>
                <MDBCollapse navbar show={showNav}>
                    { render &&
                    <MDBNavbarNav>
                        <MDBNavbarItem>
                            <MDBNavbarLink href='/calendario'>Calendario</MDBNavbarLink>
                        </MDBNavbarItem>
                        { user.role === 'admin' &&
                            <MDBNavbarItem>
                                <MDBNavbarLink href='/administrar'>Admin</MDBNavbarLink>
                            </MDBNavbarItem >
                        }
                        <MDBBtn outline color="secondary" className="ml-auto" type='button' onClick={logout}>
                            Log out
                        </MDBBtn>
                    </MDBNavbarNav>
                    }
                    { render &&
                        <img src={userPicture} alt="user profile" height='45px' loading='lazy' className='img'/>
                    }
                </MDBCollapse>
            </MDBContainer>
        </MDBNavbar>
    );
}